// extracted by mini-css-extract-plugin
module.exports = {"main-header-background":"Header_main-header-background__1pEQV","header-content-wrapper":"Header_header-content-wrapper__19445","header-content":"Header_header-content__1_L1b"};